var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BOverlay,
    { attrs: { show: _setup.loading } },
    [
      _c(
        _setup.BFormRadioGroup,
        {
          model: {
            value: _setup.selectedGlazing,
            callback: function ($$v) {
              _setup.selectedGlazing = $$v
            },
            expression: "selectedGlazing",
          },
        },
        [
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h5", [_vm._v("Standard Glass")]),
              _vm._l(_setup.glazingOptions.Standard, function (glazing, idx) {
                return _c(
                  _setup.BFormRadio,
                  {
                    key: `Standard-${idx}`,
                    staticClass: "w-100",
                    attrs: { value: glazing },
                  },
                  [
                    _c(_setup.GlazingOption, {
                      attrs: {
                        glazing: glazing,
                        "frame-size": _setup.props.frameSize,
                        "base-price": _setup.basePrice,
                        "group-id": _setup.props.groupId,
                        included: "",
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h5", [_vm._v("Acrylic Glass")]),
              _vm._l(_setup.glazingOptions.Acrylic, function (glazing, idx) {
                return _c(
                  _setup.BFormRadio,
                  {
                    key: `Acrylic-${idx}`,
                    staticClass: "w-100",
                    attrs: { value: glazing },
                  },
                  [
                    _c(_setup.GlazingOption, {
                      attrs: {
                        glazing: glazing,
                        "frame-size": _setup.props.frameSize,
                        "base-price": _setup.basePrice,
                        "group-id": _setup.props.groupId,
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h5", [_vm._v("Specialist Glass")]),
              _vm._l(_setup.glazingOptions.Specialist, function (glazing, idx) {
                return _c(
                  _setup.BFormRadio,
                  {
                    key: `Specialist-${idx}`,
                    staticClass: "w-100",
                    attrs: { value: glazing },
                  },
                  [
                    _c(_setup.GlazingOption, {
                      attrs: {
                        glazing: glazing,
                        "frame-size": _setup.props.frameSize,
                        "base-price": _setup.basePrice,
                        "group-id": _setup.props.groupId,
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }